import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];

export const CTA = () => {
  const navigate = useNavigate();
  return (
  <section id="professionals" className="border-t border-border">
    <div className="grid grid-cols-1 lg:grid-cols-2">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease }}
        className="relative bg-navy grain px-8 lg:px-16 py-20 lg:py-28"
        data-testid="cta-customer"
      >
        <div className="relative z-10">
          <p className="uppercase tracking-[0.25em] text-flame font-heading font-bold text-sm mb-6">Homeowners</p>
          <h2 className="font-heading font-black tracking-tighter text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
            Ready to start your project?
          </h2>
          <p className="text-white/60 mt-6 max-w-md text-base leading-relaxed">
            Post your request in minutes — including emergency work — and let local
            pros come to you.
          </p>
          <button
            data-testid="cta-customer-btn"
            onClick={() => navigate("/request/new")}
            className="mt-10 inline-flex items-center gap-3 bg-flame hover:bg-flame-dark text-white font-heading font-bold uppercase tracking-wider text-sm px-8 py-4 transition-transform hover:scale-[1.03]"
          >
            Get Started <ArrowRight size={16} />
          </button>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.15, ease }}
        className="bg-flame px-8 lg:px-16 py-20 lg:py-28"
        data-testid="cta-professional"
      >
        <p className="uppercase tracking-[0.25em] text-navy font-heading font-bold text-sm mb-6">Professionals</p>
        <h2 className="font-heading font-black tracking-tighter text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
          Grow your business in North Alabama.
        </h2>
        <p className="text-white/80 mt-6 max-w-md text-base leading-relaxed">
          Be among the first pros on Prime Pro. Choose your services, set your
          coverage area, and receive matched leads — no spam blasts.
        </p>
        <button
          data-testid="cta-professional-btn"
          onClick={() => navigate("/join?type=professional")}
          className="mt-10 inline-flex items-center gap-3 bg-navy hover:bg-navy-light text-white font-heading font-bold uppercase tracking-wider text-sm px-8 py-4 transition-transform hover:scale-[1.03]"
        >
          Apply to Join <ArrowRight size={16} />
        </button>
      </motion.div>
    </div>
  </section>
  );
};

export default CTA;
